import type { FunctionComponent } from 'react';
import { useIdentity } from '@whizz/react-identity';
import React, { useEffect } from 'react';
import { Loader } from '../components';
import { Header } from '../layouts/common';

const Logout: FunctionComponent = () => {
  const { logout } = useIdentity();

  useEffect(logout, []);

  return (
    <div className={'w-full'}>
      <Header hideMenu>&nbsp;</Header>
      <div className={'container my-md'}>
        <Loader label={'Logging out...'}/>
      </div>
    </div>
  );
};

export default Logout;
